import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeReturnsRoute extends Route {
  @service store;
  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    model.bon.then(async (results) => {
      const bon = results ?? this.store.createRecord('bon');
      controller.set('bon', bon);
      if (bon.id) {
        controller.get('formatBon')?.();
      }
    });
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeReturnsRoute,
);
